<template>
  <v-app>

    <v-dialog v-model="showSetLocation" width="500">
      <v-card>
        <v-btn icon class="float-right ma-2" @click="showSetLocation = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>
          Set your location to discover music near you
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 d-flex">
          <v-text-field name="location-search" placeholder="City" dense filled rounded append-icon="mdi-magnify" hide-details />
          <v-btn fab small color="primary" class="ml-4">
            <v-icon>mdi-crosshairs</v-icon>
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-navigation-drawer v-model="drawer" app>
      <v-list dense class="pa-0">
        <v-list-item link :to="{ name: 'discover' }">
          <v-list-item-action>
            <v-icon>{{profile && profile.location ? 'mdi-map-search' : 'mdi-earth'}}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Discover</v-list-item-title>
            <v-list-item-subtitle>
              {{profile && profile.location ? profile.location.name : 'Global'}}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn fab x-small :disabled="!profile" @click.stop.prevent="showSetLocation = true">
              <v-icon small>mdi-crosshairs</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <nav-item
          v-for="(type, i) in [ 'personalized', 'popular', 'new' ]" :key="i"
          :title="type[0].toUpperCase() + type.slice(1)"
          :to="{ name: 'feed', params: { type } }"
          :child="true"
          :disabled="!profile && i === 0"
        />
        <nav-item :to="{ name: 'create' }" icon="mdi-music-note-plus" title="Create" :disabled="!profile" />
        <nav-item
          icon="mdi-account" title="Profile"
          :to="{ name: 'profile', params: { userId: profile && profile.userId } }"
          :disabled="!profile"
        />
        <nav-item icon="mdi-message" title="Messages" :to="{ name: 'messages' }" :disabled="!profile" />
        <nav-item icon="mdi-information" title="About" :to="{ name: 'about' }" />
        <nav-item v-if="profile" icon="mdi-logout" title="Sign out" :to="{ name: 'sign-in' }" />
        <nav-item v-else icon="mdi-login" title="Sign in" :to="{ name: 'sign-in' }" />
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="headline">
        Make Music / Find Music - community music
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

  </v-app>
</template>

<style>
</style>

<script>
import NavItem from '@/components/NavItem.vue';

export default {
  name: 'app',
  components: {
    NavItem
  },
  data() {
    return {
      drawer: this.$vuetify.breakpoint.mdAndUp,
      showSetLocation: false,
      // profile: null,
      profile: { userId: '123', location: { name: 'Seattle / Beacon Hill' } },
    };
  },
  methods: {
    setLocation() {

    }
  },
  watch: {
  },
  mounted() {
    // TODO: wrap this functionality up into a directive

    // Disable scrolling on the body if the window is taller than this - this is particularly important to disable the scroll bounce on mobile
    const SCROLL_MAX_HEIGHT_PX = 550;

    function preventDefault(e) {
      e.preventDefault();
    }

    // Vuetify sets a min-height of '100vh' on the 'v-app' component. This doesn't work well with mobile browsers, because the collapsible address bar is not included as part of that height, thus an app that has a height of exactly '100vh' will actually be scrollable, which is counter-intuitive. This method sets the min-height directly from the window.
    function resize() {
      const vApp = document.getElementsByClassName('v-application--wrap')[0];
      vApp.style['min-height'] = window.innerHeight + 'px';

      // if (window.innerHeight > SCROLL_MAX_HEIGHT_PX) {
      //   document.body.addEventListener('touchmove', preventDefault, { passive: false });
      // } else {
      //   document.body.removeEventListener('touchmove', preventDefault);
      // }
    }
    resize();
    window.addEventListener('resize', resize);
    window.addEventListener('orientationchange', resize);
  }
}
</script>
